export const GET_FLOW = Symbol('GET_FLOW');

export function setUserFlow(val) {
    return {
        type: GET_FLOW,
        payload: val
    }
}
